import { useTranslation } from "react-i18next";
import Avatar from "src/components/Avatar";
import Button from "src/components/Button";
import Link from "src/components/Link";
import Skeleton from "src/components/Skeleton";
import useAuth from "src/hooks/selectors/useAuth";

interface ChatHeadProps {
	avatar?: string;
	name?: string;
	subtitle?: string;
	profileId?: string;
	backUrl?: string;
	taskUrl?: string;
	headActions?: any;
}

const ChatHead = ({
	avatar,
	name,
	profileId,
	backUrl,
	subtitle,
	headActions,
	taskUrl,
}: ChatHeadProps) => {
	const { t } = useTranslation("common");
	const auth = useAuth();
	const { type } = auth;
	return (
		<div
			className={`flex items-center sticky rounded-t-md top-0 z-[44] bg-white justify-between border-b-[1px] border-gray`}
		>
			<div className="flex items-center gap-2">
				{backUrl && (
					<Button
						to={backUrl}
						iconOnly
						type={type === "company" ? "dark" : "gray"}
					>
						<i className="fas fa-angle-left"></i>
					</Button>
				)}
				<Avatar src={avatar} alt={name} />
				<div className="flex flex-col">
					<strong>{name}</strong>
					{subtitle && <small>{subtitle}</small>}
				</div>
			</div>
			<div className="flex items-center gap-4">
				{headActions}

				{taskUrl && (
					<Link className="underline flex items-center" to={taskUrl}>
						<i className="fas fa-file mr-2"></i>
						<div className="hidden md:flex">
							<strong>{t("task")}</strong>
						</div>
					</Link>
				)}

				{type === "company" && profileId && (
					<Link
						className="underline flex items-center"
						to={`/view-profile/${profileId}`}
					>
						<i className="fas fa-user mr-2"></i>
						<div className="hidden md:flex">
							<strong>{t("profile")}</strong>
						</div>
					</Link>
				)}
			</div>
		</div>
	);
};

const Loading = () => {
	const { type } = useAuth();
	return (
		<div className={`flex items-center justify-between p-4 md:p-6`}>
			<div className="flex items-center gap-2">
				<Skeleton className="w-[38px] h-[38px]" />
				<Skeleton className="w-[50px] h-[50px]" />
				<Skeleton className="w-[120px] h-[27px]" />
			</div>

			{type === "company" && <Skeleton className="w-[120px] h-[27px]" />}
		</div>
	);
};

ChatHead.Loading = Loading;

export default ChatHead;
